export const APP_NAME = 'Travels';
export const DEFAULT_PAGE_SIZE = 10;
export const DATE_FORMAT = 'MMM dd, yyyy';
